<div class="body">
  <form class="form" id="accountForm" [formGroup]="accountForm" novalidate>
    <div class="top-bar">
      <span (click)="goBack()">
        <img class="h-18" src="assets/images/icon/chevronleft.svg" />
        {{ translations['back_label'] }}
      </span>
      <div class="content-start"></div>
      <div class="logo-div">
        <img
          src="assets/images/ecolab-logo-white-app-header.png"
          alt="EcoLab Logo"
          class="logo"
        />
      </div>
      <div class="content-end">
        <select
          [value]="currentLanguage"
          (change)="languageChange($event)"
          class="select-dropdown"
        >
          <option
            *ngFor="let option of languageOptions"
            [value]="option?.value"
            [selected]="option.value === currentLanguage"
          >
            {{ option.value }}
          </option>
        </select>
      </div>
    </div>
    <main class="grow overflow-hidden main">
      <div class="h-full relative show-bottom-fade">
        <div class="h-full min-h-0 border-b border-white">
          <div class="max-w-xl mx-auto pt-2 px-4">
            <div class="esr-form w-full">
              <h1 class="h1 sm:text-center">
                {{ translations['account_details_header'] }}
              </h1>
              <div class="mb-2">
                <label class="label" for="accountNumber"
                  >{{ translations['account_number'] }}
                  <span class="required">*</span>
                  <span class="px-1 required" *ngIf="!isAccountValid">{{
                    translations['invalid']
                  }}</span>
                </label>
                <input
                  id="accountNumber"
                  formControlName="accountNumber"
                  type="number"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  name="accountNumber"
                  [ngClass]="
                    !isAccountValid
                      ? 'invalid-input'
                      : !isEdit
                        ? 'input-disable'
                        : 'input'
                  "
                  (input)="onAccountNumberEntry($event)"
                  maxlength="10"
                  (keypress)="validateLength($event)"
                />
                <!-- <img
                  src="assets/images/icon/scan.png"
                  alt="Scan"
                  class="scan-sec"
                  (click)="openScanner()"
                />
                <div *ngIf="scanEnable">
                  <app-scanQrCode
                    (dataEvent)="handleData($event)"
                  ></app-scanQrCode>
                </div> -->
              </div>
              <div class="mb-2">
                <label class="label" for="accountName"
                  >{{ translations['customer_name']
                  }}<span class="required">*</span></label
                >
                <input
                  id="accountName"
                  formControlName="accountName"
                  type="text"
                  name="accountName"
                  class="input-disable"
                  [value]="accountDetails?.AccountName"
                  readonly
                />
              </div>
              <div class="mb-2">
                <label class="label" for="address"
                  >{{ translations['address']
                  }}<span class="required">*</span></label
                >
                <input
                  id="address"
                  formControlName="address"
                  type="text"
                  name="address"
                  class="input-disable"
                  [value]="accountDetails?.Address"
                  readonly
                />
              </div>
              <div class="mb-2">
                <label class="label" for="city">{{
                  translations['city']
                }}</label>
                <input
                  id="city"
                  type="text"
                  formControlName="city"
                  name="city"
                  class="input-disable"
                  [value]="accountDetails?.City"
                  readonly
                />
              </div>
              <div class="columns-2 mb-2">
                <div>
                  <label class="label" for="state"
                    >{{ translations['state']
                    }}<span class="required">*</span></label
                  >
                  <input
                    id="state"
                    type="text"
                    formControlName="state"
                    name="state"
                    class="input-disable"
                    [value]="accountDetails?.State"
                    readonly
                  />
                </div>
                <div>
                  <label class="label" for="zip"
                    >{{ translations['zip']
                    }}<span class="required">*</span></label
                  >
                  <input
                    id="zip"
                    type="text"
                    name="zip"
                    formControlName="zip"
                    class="input-disable"
                    [value]="accountDetails?.ZipCode"
                    readonly
                  />
                </div>
              </div>
              <div class="mb-3">
                <label class="label"
                  >{{ translations['dishmachine_label'] }}
                  <span class="required">*</span></label
                >
                <div class="dishmachine-container">
                  <div
                    class="dishmachine-option"
                    *ngFor="let machine of dishmachineOptions"
                  >
                    <div class="input-div">
                      <input
                        type="radio"
                        id="{{ machine.value }}"
                        name="dishmachine"
                        [value]="machine.value"
                      />
                    </div>
                    <div>
                      <label for="{{ machine.value }}">
                        <img
                          [src]="machine.image"
                          [alt]="machine.label"
                          class="dishmachine-img"
                        />
                      </label>
                    </div>
                    <div>{{ machine.label }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <div class="layout-bottom">
      <div class="max-w-xl mx-auto px-4">
        <button
          type="submit"
          [disabled]="!isAccountValid"
          class="btn-white-outline"
          (click)="isEdit ? onCancelClick() : onEditClick()"
        >
          {{ isEdit ? translations['cancel'] : translations['edit'] }}
        </button>
        <button
          type="submit"
          [disabled]="!isAccountValid"
          class="btn-blue-outline"
          (click)="isEdit ? onVerifyAccountClick() : onNextClick()"
        >
          {{ isEdit ? translations['verify'] : translations['next'] }}
        </button>
      </div>
    </div>
  </form>
</div>

<div
  class="modal fade"
  id="messageModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-body pt-4">
        <div class="err-msg">
          {{ errorMessage }}
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-center border-0">
        <!-- style="border: none" -->
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
          Ok
        </button>
      </div>
    </div>
  </div>
</div>
